// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2arlo","name":"Header_name__2oRl7","birthday":"Header_birthday__MWZEl","skeleton":"Header_skeleton__2oG1C"};